import { useEffect, useRef } from "react";
import { motion } from "framer-motion";

export function FloatingCard({ icon, title, desc, delay = 0 }) {
  return (
    <motion.div initial={{ opacity: 0, y: 40, scale: 0.9 }} whileInView={{ opacity: 1, y: 0, scale: 1 }} viewport={{ once: true, margin: "-50px" }} transition={{ duration: 0.7, delay, ease: "easeOut" }}
      className="bg-gradient-to-br from-white/[0.08] to-white/[0.03] backdrop-blur-xl border border-white/[0.1] p-6 hover:border-[#E60000]/40 hover:from-white/[0.12] hover:to-[#E60000]/[0.05] transition-all duration-500 group shadow-lg shadow-black/20">
      <div className="text-[#E60000] mb-4 group-hover:scale-110 transition-transform">{icon}</div>
      <h3 className="font-['Outfit'] text-lg font-bold text-white mb-2">{title}</h3>
      <p className="text-white/50 text-sm leading-relaxed">{desc}</p>
    </motion.div>
  );
}

export function Scene({ id, children, className = "", bg = "" }) {
  return (
    <section id={id} data-testid={`scene-${id}`} className={`relative min-h-screen flex items-center overflow-hidden ${className}`} style={bg ? { background: bg, willChange: "transform" } : { willChange: "transform" }}>
      <div className="relative z-10 w-full">{children}</div>
    </section>
  );
}

export function ProgressBar({ progressRef }) {
  const barsRef = useRef([]);
  useEffect(() => {
    let animId;
    const update = () => {
      const p = progressRef?.current || 0;
      barsRef.current.forEach((bar, i) => {
        if (bar) bar.style.backgroundColor = i / 10 <= p ? "#E60000" : "rgba(255,255,255,0.1)";
      });
      animId = requestAnimationFrame(update);
    };
    update();
    return () => cancelAnimationFrame(animId);
  }, [progressRef]);

  return (
    <div data-testid="scroll-progress" className="fixed right-4 top-1/2 -translate-y-1/2 z-[90] hidden lg:flex flex-col items-center gap-1">
      {[...Array(10)].map((_, i) => (
        <div data-testid={`scroll-progress-segment-${i}`} key={`progress-${i}`} ref={el => barsRef.current[i] = el} className="w-1 h-4 rounded-full" style={{ backgroundColor: "rgba(255,255,255,0.1)" }} />
      ))}
    </div>
  );
}
